/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Dash_Url_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Manifest URL (.mpd)" |
*
* @param {New_Project_Dash_Url_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_dash_url_placeholder = /** @type {((inputs?: New_Project_Dash_Url_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Dash_Url_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL du manifeste (.mpd)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Manifest-URL (.mpd)")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL manifesto (.mpd)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("URL манифеста (.mpd)")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL del manifiesto (.mpd)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清单网址 (.mpd)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マニフェストURL (.mpd)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मैनिफेस्ट URL (.mpd)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("URL do manifesto (.mpd)")
	return /** @type {LocalizedString} */ ("Manifest URL (.mpd)")
});